if (typeof Turbo !== 'undefined' && typeof Turbo.StreamActions !== 'undefined') {
  Turbo.StreamActions.force_full_page_redirect = function() {
    const targetUrl = this.getAttribute("url");

    if (targetUrl) {
      Turbo.visit(targetUrl); 
    } else {
      console.error("Turbo Stream Action 'force_full_page_redirect' failed: 'url' attribute not found on the <turbo-stream> element.");
    }
  };
} else {
  document.addEventListener("turbo:load", () => {
    if (typeof Turbo !== 'undefined' && typeof Turbo.StreamActions !== 'undefined' && !Turbo.StreamActions.force_full_page_redirect) {
      Turbo.StreamActions.force_full_page_redirect = function() {
        const targetUrl = this.getAttribute("url");
        if (targetUrl) {
          Turbo.visit(targetUrl);
        } else {
          console.error("Turbo Stream Action 'force_full_page_redirect' failed (lazy load): 'url' attribute not found.");
        }
      };
    }
  });
}
